import React from "react";
import './Separator.scss';

type SeparatorProps = {
  size?: 8 | 14 | 16 | 24 | 32 | 48 | 64 | 75 | 80;
};

export const Separator = ({ size }: SeparatorProps) => {
  return <div className={`c-hex-separator--${size}`} />;
};
